import { motion } from "framer-motion";
import { Sparkles, Handshake } from 'lucide-react';
import { partners } from "./data";

const PartnersCarousel = () => {
    return (
        <section className="py-32 relative overflow-hidden partners-section">

            <div className="absolute inset-0 overflow-hidden">

                {[...Array(10)].map((_, i) => (

                    <motion.div
                        key={i}
                        className="absolute w-2 h-2 bg-purple-400/20 rounded-full"
                        animate={{
                            y: [0, -100, 0],
                            x: [0, Math.random() * 50 - 25, 0],
                        }}
                        transition={{
                            duration: 4 + Math.random() * 3,
                            repeat: Infinity,
                            delay: i * 0.5
                        }}
                        style={{
                            left: `${Math.random() * 100}%`,
                            top: `${Math.random() * 100}%`,
                        }}
                    />

                ))}

            </div>

            {/* En-tête de section */}
            <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="text-center mb-16"
            >
                <div className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-blue-500/10 to-cyan-500/10 rounded-full mb-6 border border-blue-500/20">
                    <Handshake className="w-5 h-5 text-blue-400" />
                    <span className="text-blue-400 font-medium">Partenariats d'Excellence</span>
                </div>

                <h2 className="text-4xl sm:text-5xl md:text-7xl font-bold text-white mb-6 md:mb-8 leading-tight tracking-tight px-4">
                    <span className="text-white block sm:inline">Ils nous font</span>
                    <span className="bg-gradient-to-r from-blue-400 via-cyan-300 to-blue-600 bg-clip-text text-transparent px-2 sm:px-4">confiance</span>
                </h2>

                <p className="text-gray-300 text-base md:text-xl max-w-2xl mx-auto px-6">
                    Nous collaborons avec les leaders mondiaux pour vous offrir des solutions technologiques d'exception
                </p>

            </motion.div>

            {/* Conteneur du carrousel avec défilement infini */}
            <div className="relative overflow-hidden py-12">

                {/* Premier ensemble de logos (défilement infini) */}
                <div className="flex overflow-hidden">

                    <div className="flex animate-infinite-scroll">
                        {/* Dupliquer les partenaires 4 fois pour un effet de boucle continu */}
                        {[...partners, ...partners, ...partners, ...partners].map((partner, idx) => (

                            <motion.div
                                key={`${partner.id}-${idx}`}
                                initial={{ opacity: 0, scale: 0.8 }}
                                whileInView={{ opacity: 1, scale: 1 }}

                                whileHover={{ scale: 1.15 }}
                                className="group relative shrink-0 flex items-center justify-center mx-8 "
                            >
                                {/* Effet de halo au survol */}
                                <motion.div
                                    initial={{ opacity: 0, scale: 0.8 }}
                                    whileHover={{ opacity: 1, scale: 1 }}
                                    className="absolute inset-0 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 rounded-full blur-2xl -z-10"
                                />

                                {/* Conteneur du logo */}
                                <div className="relative bg-transparent p-4 transition-all duration-300 w-48 h-32 flex items-center justify-center">

                                    {/* Logo avec effet de brillance */}
                                    <div className="relative w-40 h-20 flex items-center justify-center ">

                                        <motion.img
                                            src={partner.logo}
                                            alt={partner.name}
                                            loading="lazy"
                                            className="w-full h-full object-contain filter group-hover:brightness-125 transition-all duration-300"
                                            whileHover={{
                                                scale: 1.1,
                                                transition: { duration: 0.3 }
                                            }}
                                        />

                                        {/* Effet de brillance au survol */}
                                        <motion.div
                                            initial={{ opacity: 0 }}
                                            whileHover={{ opacity: 1 }}
                                            className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-cyan-500/10 rounded-lg"
                                        />
                                    </div>

                                    {/* Indicateur de survol */}
                                    <motion.div
                                        initial={{ width: 0 }}
                                        whileHover={{ width: "100%" }}
                                        className="absolute bottom-0 left-1/2 transform -translate-x-1/2 h-1 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full"
                                    />
                                </div>

                                {/* Nom du partenaire (apparaît au survol) */}
                                <motion.div
                                    initial={{ opacity: 0, y: 10 }}
                                    whileHover={{ opacity: 1, y: 0 }}
                                    className="absolute -bottom-10 left-1/2 transform -translate-x-1/2 whitespace-nowrap"
                                >
                                    <span className="text-sm font-medium text-gray-300 bg-gray-900/80 backdrop-blur-sm px-3 py-1 rounded-full">
                                        {partner.name}
                                    </span>

                                </motion.div>

                            </motion.div>

                        ))}

                    </div>

                    {/* Deuxième ensemble (pour l'effet de boucle continu) */}
                    <div className="flex animate-infinite-scroll">
                        {[...partners, ...partners, ...partners, ...partners].map((partner, idx) => (
                            <motion.div
                                key={`${partner.id}-${idx}-2`}
                                initial={{ opacity: 0, scale: 0.8 }}
                                whileInView={{ opacity: 1, scale: 1 }}
                                transition={{ duration: 1.5, delay: idx * 0.05 }}
                                whileHover={{ scale: 1.15 }}
                                className="group relative shrink-0 flex items-center justify-center mx-8 partner-card"
                            >
                                {/* Effet de halo au survol */}
                                <motion.div
                                    initial={{ opacity: 0, scale: 0.8 }}
                                    whileHover={{ opacity: 1, scale: 1 }}
                                    className="absolute inset-0 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 rounded-full blur-2xl -z-10"
                                />

                                {/* Conteneur du logo */}
                                <div className="relative bg-transparent p-4 transition-all duration-300 w-48 h-32 flex items-center justify-center">
                                    {/* Logo avec effet de brillance */}
                                    <div className="relative w-40 h-20 flex items-center justify-center">
                                        <motion.img
                                            src={partner.logo}
                                            alt={partner.name}
                                            className="w-full h-full object-contain filter group-hover:brightness-125 transition-all duration-300"
                                            whileHover={{
                                                scale: 1.1,
                                                transition: { duration: 0.3 }
                                            }}
                                        />

                                        {/* Effet de brillance au survol */}
                                        <motion.div
                                            initial={{ opacity: 0 }}
                                            whileHover={{ opacity: 1 }}
                                            className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-cyan-500/10 rounded-lg"
                                        />
                                    </div>

                                    {/* Indicateur de survol */}
                                    <motion.div
                                        initial={{ width: 0 }}
                                        whileHover={{ width: "100%" }}
                                        className="absolute bottom-0 left-1/2 transform -translate-x-1/2 h-1 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full"
                                    />
                                </div>

                                {/* Nom du partenaire (apparaît au survol) */}
                                <motion.div
                                    initial={{ opacity: 0, y: 10 }}
                                    whileHover={{ opacity: 1, y: 0 }}
                                    className="absolute -bottom-10 left-1/2 transform -translate-x-1/2 whitespace-nowrap"
                                >
                                    <span className="text-sm font-medium text-gray-300 bg-gray-900/80 backdrop-blur-sm px-3 py-1 rounded-full">
                                        {partner.name}
                                    </span>
                                </motion.div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Style pour l'animation de défilement infini */}
            <style jsx>{`
        @keyframes infinite-scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .animate-infinite-scroll {
          animation: infinite-scroll 200s linear infinite;
          display: flex;
          width: max-content;
        }

        .animate-infinite-scroll:hover {
          animation-play-state: paused;
        }

        /* Pour un défilement plus lent sur mobile */
        @media (max-width: 768px) {
          .animate-infinite-scroll {
            animation: infinite-scroll 60s linear infinite;
          }
        }
      `}</style>
        </section>
    );
};

//                         className="absolute w-1.5 h-1.5 bg-blue-500/20 rounded-full"
//                         animate={{
//                             y: [0, -80, 0],
//                             opacity: [0, 0.5, 0],
//                         }}
//                         transition={{
//                             duration: 3 + Math.random() * 4,
//                             repeat: Infinity,
//                             delay: i * 0.8
//                         }}
//                         style={{
//                             left: `${Math.random() * 100}%`,
//                             top: `${Math.random() * 100}%`,
//                         }}
//                     />
//                 ))}
//             </div>

//             {/* En-tête de section */}
//             <motion.div
//                 initial={{ opacity: 0, y: 20 }}
//                 whileInView={{ opacity: 1, y: 0 }}
//                 viewport={{ once: true }}
//                 transition={{ duration: 0.6 }}
//                 className="text-center mb-12"
//             >
//                 <div className="inline-flex items-center gap-2 px-5 py-2 bg-gradient-to-r from-blue-500/10 to-cyan-500/10 rounded-full mb-6 border border-blue-500/20">
//                     <Handshake className="w-4 h-4 text-blue-400" />
//                     <span className="text-blue-400 text-sm font-medium">ECOSYSTÈME</span>
//                 </div>

//                 <h2 className="text-4xl md:text-5xl font-bold mb-4">
//                     <span className="text-white">Ils nous font</span>
//                     <span className="bg-gradient-to-r from-blue-400 via-cyan-400 to-blue-500 bg-clip-text text-transparent ml-3">confiance</span>
//                 </h2>

//                 <p className="text-gray-400 text-base max-w-xl mx-auto">
//                     Collaboration avec les leaders technologiques pour des solutions d'exception
//                 </p>

//             </motion.div>

//             {/* Conteneur du carrousel avec défilement infini - Optimisé */}
//             <div className="relative overflow-hidden py-10 mask-linear-gradient">

//                 {/* Masques de dégradé sur les côtés pour effet de fondu */}
//                 <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-black to-transparent z-10"></div>
//                 <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-black to-transparent z-10"></div>

//                 <div className="flex animate-infinite-scroll">
//                     {/* Dupliquer x4 pour flux continu garanti */}
//                     {[...partners, ...partners, ...partners, ...partners].map((partner, idx) => (

//                         <div
//                             key={`${partner.id}-${idx}`}
//                             className="relative shrink-0 flex items-center justify-center mx-6 md:mx-10 group"
//                         >
//                             {/* Conteneur du logo */}
//                             <div className="relative w-40 h-24 flex items-center justify-center bg-gray-900/40 backdrop-blur-sm rounded-xl border border-gray-800/50 group-hover:border-blue-500/30 group-hover:bg-gray-800/60 transition-all duration-300">

//                                 <img
//                                     src={partner.logo}
//                                     alt={partner.name}
//                                     className="w-28 h-12 object-contain filter grayscale opacity-60 group-hover:grayscale-0 group-hover:opacity-100 transition-all duration-300 transform group-hover:scale-110"
//                                 />

//                                 {/* Glow subtil au hover */}
//                                 <div className="absolute inset-0 bg-blue-500/5 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none" />
//                             </div>
//                         </div>

//                     ))}
//                 </div>
//             </div>

//             {/* Style pour l'animation de défilement infini */}
//             <style jsx>{`
//         @keyframes infinite-scroll {
//           0% {
//             transform: translateX(0);
//           }
//           100% {
//             transform: translateX(-50%);
//           }
//         }

//         .animate-infinite-scroll {
//           animation: infinite-scroll 40s linear infinite;
//           display: flex;
//           width: max-content;
//         }

//         .animate-infinite-scroll:hover {
//           animation-play-state: paused;
//         }

//         /* Mobile speed optimized */
//         @media (max-width: 768px) {
//           .animate-infinite-scroll {
//             animation: infinite-scroll 25s linear infinite;
//           }
//         }
//       `}</style>
//         </section>
//     );
// };

export default PartnersCarousel;
